import { Button, DatePicker, Form, Input, Modal, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getAllMaster } from "../../../redux/rtk/features/masters/masterSlice";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { addEmploymentStatus } from "../../../redux/rtk/features/employemntStatus/employmentStatusSlice";
import { loadSingleStaff } from "../../../redux/rtk/features/user/userSlice";

const EmploymentAddSinglePopup = ({ list, setLoading }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { id } = useParams();
    const masterData = useSelector((state) => state.masters.masters);
  const Option = Select;
    useEffect(() => {
      dispatch(getAllMaster());
    }, [dispatch]);
  
    const showModal = () => {
      setIsModalOpen(true);
    };
  
    const handleCancel = () => {
      setIsModalOpen(false);
      form.resetFields();
    };
  
    const onFinish = async (values) => {
      try {
        setLoading(true);
        const response = await dispatch(addEmploymentStatus({
          ...values,
          EmploymentTypeHistoryId:0,
          EmployeeId: id,
          DataStatus: 1,
        }));
        if (response.payload.message === "success") {
          dispatch(loadSingleStaff(id));
          setIsModalOpen(false);
          form.resetFields();
        }
      } catch (error) {
        // console.error("Error adding employment history:", error);
      } finally {
        setLoading(false);
      }
    };
  
    return (
      <>
        <Button type="primary" onClick={showModal} className="mb-4">
          Add New Employment Status
        </Button>
        <Modal
          title="Add Employment Status"
          open={isModalOpen}
          onCancel={handleCancel}
          footer={null}
        >
          <Form
            form={form}
            name="addEmploymentStatus"
            layout="vertical"
            onFinish={onFinish}
          >
            <Form.Item
              label="Employment Type"
              name="EmploymentTypeId"
              rules={[{ required: true, message: "Please select an employment type!" }]}
            >
              <Select 
                placeholder="Select employment type" 
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {masterData?.EmploymentTypeMaster?.map((type) => (
                  <Option key={type.EmploymentTypeId} value={type.EmploymentTypeId}>
                    {type.EmploymentTypeName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Effective From"
              name="EffectedFrom"
              rules={[{ required: true, message: "Please enter the effective from date!" }]}
            >
              <DatePicker />
            </Form.Item>
             <Form.Item
              label="Effective To"
              name="EffectedTo"
              // rules={[{ required: true, message: "Please enter the effective from date!" }]}
            >
              <DatePicker />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Add
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </>
    );
  };
export default EmploymentAddSinglePopup  